import {useContext, useEffect} from "react";
import {useNavigate} from "react-router-dom";
import {isElectron} from "../helpers/ElectronHelper";
import {PantheonSessionHelper} from "../helpers/PantheonSessionHelper";
import {AuthContext} from "../contexts/AuthContext";

export const ElectronWrapper = (props: { children?: React.ReactNode }) => {
    const navigate = useNavigate();
    const {UserInfo} = useContext(AuthContext);

    useEffect(() => {
        const handleDeepLink = (arg: string) => {
            if (!arg?.startsWith("onix://")) {
                return;
            }

            const parsedUrl = new URL(arg);
            const action = parsedUrl.host || parsedUrl.pathname.replace(/^\/+/, "");

            switch (action) {
                case "startPantheonSession":
                    PantheonSessionHelper.startPantheonSessionFromDeepLink(
                        parsedUrl,
                        UserInfo,
                    );
                    break;
                default:
                    const regularPath = arg.replace("onix://", "");
                    // window.location = regularPath;
                    navigate(regularPath);
                    break;
            }
        };

        const onixDesktop = (window as any)?.onixDesktop;
        const unsubscribeOnixDesktopDeepLink =
            typeof onixDesktop?.onDeepLink === "function"
                ? onixDesktop.onDeepLink(handleDeepLink)
                : undefined;

        if (isElectron({})) {
            const electronRequire = (window as any).require;
            if (typeof electronRequire !== "function") {
                return unsubscribeOnixDesktopDeepLink;
            }

            // OVO RADI!
            // const fs = window.require("fs");
            // fs.readFile("C:\\Users\\Public\\Documents\\OnixWeb\\license.txt", "utf8", (err: any, data: any) => {
            //     if (err) {
            //         console.error(err);
            //         return;
            //     }
            //     registerLicense(data);
            // });

            let ipcRenderer: any;
            try {
                ipcRenderer = electronRequire("electron")?.ipcRenderer;
            } catch {
                return unsubscribeOnixDesktopDeepLink;
            }

            if (!ipcRenderer) {
                return unsubscribeOnixDesktopDeepLink;
            }

            const onDeepLinking = (_event: any, arg: any) => handleDeepLink(arg);

            ipcRenderer.on("deep-linking", onDeepLinking);

            return () => {
                ipcRenderer.removeListener?.("deep-linking", onDeepLinking);
                unsubscribeOnixDesktopDeepLink?.();
            };
        }

        return unsubscribeOnixDesktopDeepLink;
    }, [UserInfo, navigate]);

    return props.children;
};
